import classNames from "classnames";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Context } from "../../store";
import { closeModals } from "../../store/reducer";

export const CloseButton = ({ className }) => {
  const [, dispatch] = useContext(Context);

  const onClose = () => {
    dispatch(closeModals());
  };

  return (
    <button
      onClick={onClose}
      className={classNames({ [className]: className })}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="button_close"
        width="36"
        height="36"
        viewBox="0 0 36 36"
      >
        <g id="Gruppe_2">
          <path
            id="Pfad_1"
            fill="rgba(0,0,0,0.4)"
            d="M18 35.5A17.5 17.5 0 0 1 5.626 5.626a17.5 17.5 0 1 1 24.748 24.748A17.381 17.381 0 0 1 18 35.5z"
          />
          <path
            id="Pfad_2"
            d="M18 1A17 17 0 0 0 5.98 30.02 17 17 0 1 0 30.02 5.98 16.879 16.879 0 0 0 18 1m0-1A18 18 0 1 1 0 18 18 18 0 0 1 18 0z"
            fill="#fff"
          />
        </g>
        <g id="Gruppe_3">
          <path
            id="Pfad_3"
            d="M7.479 16.378V8.9H0V7.621h7.479V.143h1.278v7.478h7.478V8.9H8.757v7.479z"
            fill="#fff"
            transform="translate(29.427 17.945) rotate(135)"
          />
        </g>
      </svg>
    </button>
  );
};

export const RepeatButton = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <button
      onClick={onClick}
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.4)",
        minWidth: "6rem",
      }}
      className="text-white border border-solid px-3 py-1 rounded-lg hover__target-unique mx-3"
    >
      {t("Repeat")}
    </button>
  );
};

export const ContinueButton = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <button
      onClick={onClick}
      className="px-3 py-1 rounded-lg border border-solid mx-3"
      style={{
        backgroundColor: "var(--orange)",
        borderColor: "var(--orange)",
        minWidth: "6rem",
      }}
    >
      {t("Continue")}
    </button>
  );
};

export const OptionButton = ({
  text,
  index,
  onClick,
  withBefore = true,
  className,
}) => {
  const { t } = useTranslation();
  return (
    <button
      data-key={!isNaN(index) ? index + 1 : ""}
      onClick={onClick}
      className={classNames(
        "text-xl block w-full p-2 rounded-lg text-left items-center bg-white text-black cursor-pointer answer",
        {
          "answer-before": withBefore,
          [className]: className,
        }
      )}
    >
      <p className="md:inline-block">{t(text)}</p>
    </button>
  );
};
